import styled from 'styled-components';

export const EditSendCompanyFormStyled = styled.div`
  .body_form_campaign {
    background: white;
    width: 450px;
    padding: 20px;
    .input_type_wrap {
      margin-bottom: 20px;
      display: flex;
      width: 100%;
      .itw_left_box {
        width: 30%;
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }
      .itw_right_box {
        // width: 40%;
        flex: 1;
      }
    }
    .input_warp {
      margin-bottom: 20px;
      display: flex;
      width: 100%;
      &.mt30 {
        margin-top: 30px;
      }
      .left_box {
        width: 30%;
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }
      .right_box {
        // width: 80%;
        flex: 1;
        display: flex;
        align-items: flex-start;
      }
    }
    .btn_zone {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      column-gap: 10px;
      .w120 {
        width: 120px;
      }
    }
  }
`;
